import { ApiService } from '@/features/api';

import SingleSignOnLoginRequest from '../models/singleSignOnLoginRequest';

function getSingleSignOnLoginRequest(email: string): Promise<SingleSignOnLoginRequest> {
  return ApiService.post<SingleSignOnLoginRequest>(
    `${import.meta.env.APP_URLS_API_URL}/v1/singleSignOn/login`,
    {
      body: email,
    }
  );
}

function getUserSessionFromCode(code: string): Promise<string> {
  return ApiService.get(
    `${import.meta.env.APP_URLS_API_URL}/v1/singleSignOn/userSession?code=${code}`,
    null,
    true
  );
}

export { getSingleSignOnLoginRequest, getUserSessionFromCode };
